export default {"src":"/_next/static/media/satisfaction.df9b710e.svg","height":148,"width":282,"blurWidth":0,"blurHeight":0};